<template>
  <a-modal
    :title="title"
    :visible="visible"
    :centered="true"
    :width="width"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <div :class="singleBtn ? 'single' : ''">
        <a-button key="back" @click="handleCancel">
          {{ singleBtn ? '关闭' : '取消' }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          @click="handleOk"
          v-if="!singleBtn"
        >
          确认
        </a-button>
      </div>
    </template>

    <slot></slot>
  </a-modal>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      require: true,
      default: '操作',
    },
    visible: {
      type: Boolean,
      require: true,
    },
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '680px',
    },
    singleBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleCancel() {
      this.$emit('popupCancle');
    },
    handleOk() {
      this.$emit('popupOk');
    },
  },
};
</script>
<style scoped>
::v-deep .ant-modal-content .ant-modal-body {
  height: 500px;
  overflow: auto;
}
.single {
  text-align: center;
}
</style>
